var _defs, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAngry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "base",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 342.94 276.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1,\n      .cls-2 {\n        fill: none;\n        stroke-linecap: round;\n        stroke-miterlimit: 10;\n      }\n      .cls-1 {\n        stroke: #5d3233;\n        stroke-width: 20px;\n      }\n      .cls-2 {\n        stroke: #3d3327;\n        stroke-width: 14px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M285.31,498.19s98.24-68.67,206,0",
    transform: "translate(-219.01 -231.2)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M437.41,270.78S477,219.41,555,245.69",
    transform: "translate(-219.01 -231.2)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M226,245.42S284.69,217.88,342,277",
    transform: "translate(-219.01 -231.2)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngry);
export default __webpack_public_path__ + "static/media/angry.074b4d09.svg";
export { ForwardRef as ReactComponent };